module.exports = __webpack_public_path__ + "static/media/zheng9@3x.59cb2037.png";